import { SVGAssets } from '@business/assets/vectors';
import { ContextMenuItem } from '@business/workflows/ComponentUI';
import { useState, useCallback } from 'react';
import { useTrashRestoreDelete } from './TrashRestoreDelete';

const contextMenuIconClassName = 'w-4 h-4 text-[#505050]';
const contextMenuIconClassNameRed = 'w-4 h-4 text-red-600';

export const useAssetTrashContextMenu = () => {
  const [selectedAsset, setSelectedAsset] = useState<any>(null);
  const [isDeleteAssetConfirm, setIsDeleteAssetConfirm] =
    useState<boolean>(false);
  const [restoreAssetId, setRestoreAssetId] = useState<string>('');
  const [isAssetRestoreConfirm, setIsAssetRestoreConfirm] =
    useState<boolean>(false);

  const { deleteItem, restoreItem } = useTrashRestoreDelete();

  const handleDeleteAsset = (
    assetId: string,
    onSuccess?: () => void,
    onError?: (error: any) => void
  ) => {
    deleteItem({
      module: 'assets',
      moduleId: assetId,
      onSuccess: () => {
        setSelectedAsset(null);
        setIsDeleteAssetConfirm(false);
        onSuccess?.();
      },
      onError
    });
  };

  const handleRestoreAsset = (
    assetId: string,
    onSuccess?: () => void,
    onError?: (error: any) => void
  ) => {
    restoreItem({
      module: 'assets',
      moduleId: assetId,
      onSuccess: () => {
        setRestoreAssetId('');
        setIsAssetRestoreConfirm(false);
        onSuccess?.();
      },
      onError: err => {
        setIsAssetRestoreConfirm(false);
        onError?.(err);
      }
    });
  };

  const assetContextMenuItems = useCallback(
    (asset: any) => [
      {
        id: '1',
        label: (
          <ContextMenuItem
            icon={
              <SVGAssets.ProfileEditIcon className={contextMenuIconClassName} />
            }
            label="Restore"
          />
        ),
        onClick: () => {
          setRestoreAssetId(asset?.id);
          setIsAssetRestoreConfirm(true);
        }
      },
      {
        id: '2',
        label: (
          <ContextMenuItem
            icon={
              <SVGAssets.TrashIcon className={contextMenuIconClassNameRed} />
            }
            label="Delete"
            labelClassName="text-red-600"
          />
        ),
        onClick: () => {
          setSelectedAsset(asset?.id);
          setIsDeleteAssetConfirm(true);
        }
      }
    ],
    []
  );

  return {
    assetContextMenuItems,
    selectedAsset,
    setSelectedAsset,
    isDeleteAssetConfirm,
    setIsDeleteAssetConfirm,
    restoreAssetId,
    setRestoreAssetId,
    isAssetRestoreConfirm,
    setIsAssetRestoreConfirm,
    handleDeleteAsset,
    handleRestoreAsset
  };
};
